var map = {
	"./images/about/background-light.png": 1654,
	"./images/about/background.png": 1655,
	"./images/about/banner-id.jpg": 1656,
	"./images/about/banner-my.jpg": 1657,
	"./images/about/banner-ph.jpg": 1658,
	"./images/about/banner-ru.jpg": 1659,
	"./images/about/banner.jpg": 1660,
	"./images/about/partner-title-light.png": 1661,
	"./images/about/partner-title.png": 1662,
	"./images/about/partners-id.png": 1663,
	"./images/about/partners-id__for_dark_bg.png": 1664,
	"./images/about/partners-my.png": 1665,
	"./images/about/partners-ph.png": 1666,
	"./images/about/partners-ru.png": 1667,
	"./images/about/vertical-dot-gray.png": 1668,
	"./images/about/vertical-dot.png": 1669,
	"./images/activities/common/popup-mlbb-id-10diamond.png": 1670,
	"./images/activities/common/popup-mlbb-id-222diamond.png": 1671,
	"./images/activities/common/popup-mlbb-id-74diamond.png": 1672,
	"./images/activities/coupon/Subtract.png": 1379,
	"./images/activities/coupon/border.png": 1380,
	"./images/activities/coupon/cancel.png": 1381,
	"./images/activities/coupon/coupon-bg-not-login.png": 1382,
	"./images/activities/coupon/coupon-gift-left-double.png": 1383,
	"./images/activities/coupon/coupon-gift-left-one.png": 1384,
	"./images/activities/coupon/coupon-gift-top.png": 1385,
	"./images/activities/coupon/facebook-icon.png": 1386,
	"./images/activities/coupon/google-icon.png": 1387,
	"./images/activities/coupon/guide-header.png": 1130,
	"./images/activities/coupon/login/facebook.png": 1388,
	"./images/activities/coupon/login/google.png": 1119,
	"./images/activities/coupon/login/vk.png": 1120,
	"./images/activities/coupon/loginbtn-facebook.png": 1389,
	"./images/activities/coupon/loginbtn-google.png": 1121,
	"./images/activities/coupon/notice-background-header.png": 1390,
	"./images/activities/coupon/submit.png": 1391,
	"./images/activities/coupon/use-coupon.gif": 1673,
	"./images/activities/fission/banner-new.png": 1063,
	"./images/activities/fission/card-bg-1.png": 1132,
	"./images/activities/fission/card-bg-2.png": 1133,
	"./images/activities/fission/card-bg-3-old.png": 1134,
	"./images/activities/fission/card-bg-3.png": 1135,
	"./images/activities/fission/card-bg-small.png": 1136,
	"./images/activities/fission/coupon-icon.png": 1137,
	"./images/activities/fission/genshin/button-bg.png": 1138,
	"./images/activities/fission/genshin/coupon.png": 1031,
	"./images/activities/fission/genshin/coupon_bg.png": 1139,
	"./images/activities/fission/genshin/coupon_bg_popup_1.png": 1140,
	"./images/activities/fission/genshin/coupon_bg_popup_2.png": 1141,
	"./images/activities/fission/genshin/gift_bg.png": 1142,
	"./images/activities/fission/genshin/gift_bg_popup_1.png": 1143,
	"./images/activities/fission/genshin/gift_bg_popup_2.png": 1144,
	"./images/activities/fission/genshin/kGold.png": 1030,
	"./images/activities/fission/genshin/popup-bg-1.png": 1145,
	"./images/activities/fission/genshin/popup-bg-2.png": 1146,
	"./images/activities/fission/genshin/popup-bg-invited.png": 1147,
	"./images/activities/fission/genshin/popup-bg_GT.png": 1148,
	"./images/activities/fission/genshin/popup-btn-guest-login.png": 1149,
	"./images/activities/fission/genshin/popup-btn-guest.png": 1150,
	"./images/activities/fission/genshin/popup-btn-owner.png": 1151,
	"./images/activities/fission/icon/award__coupon.png": 1009,
	"./images/activities/fission/icon/coupon-new.png": 1023,
	"./images/activities/fission/icon/coupon.png": 1008,
	"./images/activities/fission/icon/facebook.png": 1060,
	"./images/activities/fission/icon/gift.png": 1041,
	"./images/activities/fission/icon/google.png": 1061,
	"./images/activities/fission/icon/kgold-new.png": 1024,
	"./images/activities/fission/icon/kgold.png": 999,
	"./images/activities/fission/icon/score-icon.png": 1015,
	"./images/activities/fission/icon/uc-new.png": 1025,
	"./images/activities/fission/mlbb-banner.png": 1093,
	"./images/activities/fission/mlbb.png": 1152,
	"./images/activities/fission/mobile-legends/award.png": 1153,
	"./images/activities/fission/mobile-legends/button-bg.png": 1154,
	"./images/activities/fission/mobile-legends/coupon-icon.png": 1155,
	"./images/activities/fission/mobile-legends/coupon_bg.png": 1071,
	"./images/activities/fission/mobile-legends/coupon_bg_popup_1.png": 1156,
	"./images/activities/fission/mobile-legends/coupon_bg_popup_2.png": 1157,
	"./images/activities/fission/mobile-legends/gift_bg.png": 1072,
	"./images/activities/fission/mobile-legends/gift_bg_popup_1.png": 1158,
	"./images/activities/fission/mobile-legends/gift_bg_popup_2.png": 1159,
	"./images/activities/fission/mobile-legends/payment-award__sku.png": 1160,
	"./images/activities/fission/mobile-legends/popover-coupon-icon.png": 1029,
	"./images/activities/fission/mobile-legends/popup-bg-1.png": 1161,
	"./images/activities/fission/mobile-legends/popup-bg-2.png": 1162,
	"./images/activities/fission/mobile-legends/popup-bg-invited.png": 1163,
	"./images/activities/fission/mobile-legends/popup-bg_GT.png": 1164,
	"./images/activities/fission/mobile-legends/popup-btn-guest.png": 1165,
	"./images/activities/fission/mobile-legends/popup-btn-owner.png": 1166,
	"./images/activities/fission/mobile-legends/register-award__sku.png": 1167,
	"./images/activities/fission/mobile-legends/score-icon.png": 1064,
	"./images/activities/fission/mobile-legends/sku-icon.png": 1168,
	"./images/activities/fission/parachute.png": 1073,
	"./images/activities/fission/pubgm/award-bg.png": 1169,
	"./images/activities/fission/pubgm/award-icon-1.png": 1170,
	"./images/activities/fission/pubgm/award__sku.png": 1171,
	"./images/activities/fission/pubgm/big-sku-icon.png": 1172,
	"./images/activities/fission/pubgm/button-bg.png": 1173,
	"./images/activities/fission/pubgm/coupon-icon.png": 1174,
	"./images/activities/fission/pubgm/coupon-sharee-bg.png": 1175,
	"./images/activities/fission/pubgm/coupon-sharer-bg.png": 1176,
	"./images/activities/fission/pubgm/coupon_bg.png": 1177,
	"./images/activities/fission/pubgm/coupon_bg_popup_1.png": 1178,
	"./images/activities/fission/pubgm/coupon_bg_popup_2.png": 1179,
	"./images/activities/fission/pubgm/gift_bg.png": 1180,
	"./images/activities/fission/pubgm/gift_bg_popup_1.png": 1181,
	"./images/activities/fission/pubgm/gift_bg_popup_2.png": 1182,
	"./images/activities/fission/pubgm/login-btn-new.png": 1183,
	"./images/activities/fission/pubgm/popover-coupon-icon.png": 1005,
	"./images/activities/fission/pubgm/popup-bg-1.png": 1184,
	"./images/activities/fission/pubgm/popup-bg-2.png": 1185,
	"./images/activities/fission/pubgm/popup-bg-bottom.png": 1186,
	"./images/activities/fission/pubgm/popup-bg-invited.png": 1187,
	"./images/activities/fission/pubgm/popup-bg_GT.png": 1188,
	"./images/activities/fission/pubgm/popup-btn-guest.png": 1189,
	"./images/activities/fission/pubgm/popup-btn-owner.png": 1190,
	"./images/activities/fission/pubgm/popup-top-icon.png": 1191,
	"./images/activities/fission/pubgm/pubgm-bg.png": 1192,
	"./images/activities/fission/pubgm/pubgm-personage.png": 1032,
	"./images/activities/fission/pubgm/score-icon.png": 1065,
	"./images/activities/fission/pubgm/sku-icon.png": 1193,
	"./images/activities/fission/pubgm/small-coupon-icon.png": 1194,
	"./images/activities/fission/pubgm/small-sku-icon.png": 1195,
	"./images/activities/fission/pubgm/toplupe-pubgm.png": 1033,
	"./images/activities/fission/score-bg.png": 1196,
	"./images/activities/fission/submit-bg.png": 1197,
	"./images/activities/fission/tip-bg.png": 1198,
	"./images/activities/fission/user-bg.png": 1062,
	"./images/activities/getlucky/banner_l.png": 1432,
	"./images/activities/getlucky/banner_m.png": 1433,
	"./images/activities/getlucky/completed.png": 1393,
	"./images/activities/getlucky/corner-marker.png": 1674,
	"./images/activities/getlucky/corner.png": 1675,
	"./images/activities/getlucky/count-down-header.png": 1676,
	"./images/activities/getlucky/empty.png": 1341,
	"./images/activities/getlucky/failure.png": 1434,
	"./images/activities/getlucky/header_bg.png": 1677,
	"./images/activities/getlucky/mobile-legends.png": 1678,
	"./images/activities/getlucky/pending.png": 1435,
	"./images/activities/getlucky/placeOrder.png": 1436,
	"./images/activities/getlucky/progress-bg.png": 1679,
	"./images/activities/getlucky/share_square.png": 1437,
	"./images/activities/getlucky/smile.png": 1438,
	"./images/activities/getlucky/submit-btn.png": 1680,
	"./images/activities/getlucky/title-bg.png": 1681,
	"./images/activities/getlucky/trophy.png": 1439,
	"./images/activities/luckydraw/activity_entry.png": 1588,
	"./images/activities/luckydraw/br/lucky-draw-center.png": 1682,
	"./images/activities/luckydraw/br/prize0.png": 1683,
	"./images/activities/luckydraw/br/prize0_active.png": 1684,
	"./images/activities/luckydraw/br/prize1.png": 1685,
	"./images/activities/luckydraw/br/prize1_active.png": 1686,
	"./images/activities/luckydraw/br/prize2.png": 1687,
	"./images/activities/luckydraw/br/prize2_active.png": 1688,
	"./images/activities/luckydraw/br/prize3.png": 1689,
	"./images/activities/luckydraw/br/prize3_active.png": 1690,
	"./images/activities/luckydraw/green-btn-long.png": 1691,
	"./images/activities/luckydraw/green-btn.gif": 1692,
	"./images/activities/luckydraw/green-btn.png": 1693,
	"./images/activities/luckydraw/grey-btn.png": 1694,
	"./images/activities/luckydraw/icon-coupon.png": 1440,
	"./images/activities/luckydraw/icon-share.png": 1441,
	"./images/activities/luckydraw/id/prize0.png": 1695,
	"./images/activities/luckydraw/id/prize0_active.png": 1696,
	"./images/activities/luckydraw/id/prize1.png": 1697,
	"./images/activities/luckydraw/id/prize1_active.png": 1698,
	"./images/activities/luckydraw/id/prize2.png": 1699,
	"./images/activities/luckydraw/id/prize2_active.png": 1700,
	"./images/activities/luckydraw/id/prize3.png": 1701,
	"./images/activities/luckydraw/id/prize3_active.png": 1702,
	"./images/activities/luckydraw/in/prize0.png": 1703,
	"./images/activities/luckydraw/in/prize0_active.png": 1704,
	"./images/activities/luckydraw/in/prize1.png": 1705,
	"./images/activities/luckydraw/in/prize1_active.png": 1706,
	"./images/activities/luckydraw/in/prize2.png": 1707,
	"./images/activities/luckydraw/in/prize2_active.png": 1708,
	"./images/activities/luckydraw/lucky-draw-bg.png": 1342,
	"./images/activities/luckydraw/lucky-draw-container.png": 1442,
	"./images/activities/luckydraw/lucky-draw-intro-popup.png": 1443,
	"./images/activities/luckydraw/lucky-draw-intro.png": 1709,
	"./images/activities/luckydraw/lucky-grid-center.png": 1122,
	"./images/activities/luckydraw/orange-btn.gif": 1710,
	"./images/activities/luckydraw/orange-btn.png": 1711,
	"./images/activities/luckydraw/square.png": 1712,
	"./images/activities/luckydraw/swiper-bg.png": 1713,
	"./images/activities/phoneCard/phone-card-used-bg.png": 1714,
	"./images/activities/ranking/1.png": 1394,
	"./images/activities/ranking/2.png": 1395,
	"./images/activities/ranking/3.png": 1396,
	"./images/activities/ranking/avatar.png": 1397,
	"./images/activities/ranking/crown-1.png": 1199,
	"./images/activities/ranking/crown-2.png": 1200,
	"./images/activities/ranking/crown-3.png": 1201,
	"./images/activities/ranking/header-bg.png": 1094,
	"./images/activities/ranking/like.gif": 1715,
	"./images/activities/ranking/like.png": 1066,
	"./images/activities/ranking/logo.png": 1095,
	"./images/activities/ranking/no-ranking.png": 1202,
	"./images/activities/ranking/prize-bg.png": 1398,
	"./images/activities/ranking/prize-top-bg.png": 1399,
	"./images/activities/ranking/ranking-bg-1.png": 1400,
	"./images/activities/ranking/ranking-bg-2.png": 1401,
	"./images/activities/ranking/ranking-bg-3.png": 1402,
	"./images/activities/ranking/start.png": 1096,
	"./images/activities/ranking/top-up-bottom.png": 1403,
	"./images/activities/ranking/top-up-popup.png": 1404,
	"./images/activities/ranking/top-up.png": 1405,
	"./images/activities/ranking/unlike.png": 1203,
	"./images/bindInfos/b-0.png": 1716,
	"./images/bindInfos/b-1.png": 1717,
	"./images/bindInfos/b-2.png": 1718,
	"./images/bindInfos/b-3.png": 1719,
	"./images/common/add_to_shortcut.png": 1444,
	"./images/common/added_to_shortcut.png": 1445,
	"./images/common/api-loading-1.gif": 1720,
	"./images/common/api-loading.gif": 1721,
	"./images/common/api-loading.png": 1446,
	"./images/common/api-loading.webp": 626,
	"./images/common/app-store-logo/AppleStore.png": 1406,
	"./images/common/app-store-logo/GetApps.png": 1407,
	"./images/common/app-store-logo/GooglePlay.png": 1408,
	"./images/common/arrow/left_orange.png": 1447,
	"./images/common/arrow/right_grey.png": 1448,
	"./images/common/bind-back-1.png": 1449,
	"./images/common/bind-back-2.png": 1450,
	"./images/common/bind-back-3.png": 1451,
	"./images/common/br_icon.png": 1452,
	"./images/common/check_success.png": 1343,
	"./images/common/check_success_blue.png": 1453,
	"./images/common/copy.png": 1204,
	"./images/common/coupon-success.png": 1454,
	"./images/common/discount-arrow.png": 1455,
	"./images/common/discount-banner.png": 1456,
	"./images/common/discount-lm-yellow.png": 1457,
	"./images/common/discount-lm.png": 1458,
	"./images/common/facebook.png": 1344,
	"./images/common/facebook_blackandwhite.png": 1459,
	"./images/common/failure.png": 1409,
	"./images/common/feedback.png": 1460,
	"./images/common/flag-icon/flag_br.png": 1047,
	"./images/common/flag-icon/flag_de.png": 1048,
	"./images/common/flag-icon/flag_es.png": 1049,
	"./images/common/flag-icon/flag_fr.png": 1050,
	"./images/common/flag-icon/flag_id.png": 1051,
	"./images/common/flag-icon/flag_in.png": 1052,
	"./images/common/flag-icon/flag_it.png": 1053,
	"./images/common/flag-icon/flag_my.png": 1054,
	"./images/common/flag-icon/flag_ph.png": 1055,
	"./images/common/flag-icon/flag_ru.png": 1056,
	"./images/common/flag-icon/flag_th.png": 1057,
	"./images/common/flag-icon/flag_tr.png": 1058,
	"./images/common/flag-icon/flag_uz.png": 1059,
	"./images/common/flag-icon/flag_СНГ.png": 1014,
	"./images/common/home_logo-2.png": 1376,
	"./images/common/home_logo.png": 1377,
	"./images/common/icon/avatar.png": 993,
	"./images/common/icon/avatar_bg.png": 1461,
	"./images/common/icon/contact-about.png": 1462,
	"./images/common/icon/contact-delivery.png": 1463,
	"./images/common/icon/contact-payment.png": 1464,
	"./images/common/icon/contact-suggestion.png": 1465,
	"./images/common/icon/contact-technical-issues.png": 1466,
	"./images/common/icon/contact-technique.png": 1467,
	"./images/common/icon/contact-tutorial.png": 1468,
	"./images/common/icon/email.png": 1575,
	"./images/common/icon/error.png": 1469,
	"./images/common/icon/facebook-c.png": 1470,
	"./images/common/icon/facebook.png": 1571,
	"./images/common/icon/facebook.svg": 1722,
	"./images/common/icon/faq.png": 1471,
	"./images/common/icon/faq.svg": 1723,
	"./images/common/icon/feedback-history.png": 1472,
	"./images/common/icon/google.png": 1318,
	"./images/common/icon/icon-feedback-history.png": 1473,
	"./images/common/icon/left_arrow.png": 1474,
	"./images/common/icon/link.png": 1577,
	"./images/common/icon/login-facebook-icon.png": 1475,
	"./images/common/icon/login-google-icon.png": 1374,
	"./images/common/icon/logo.png": 1345,
	"./images/common/icon/logout.png": 1346,
	"./images/common/icon/messenger.png": 1574,
	"./images/common/icon/notice.png": 1347,
	"./images/common/icon/privacy.png": 1476,
	"./images/common/icon/privacy_policy.png": 1477,
	"./images/common/icon/red_rec.png": 1478,
	"./images/common/icon/right_arrow.png": 1479,
	"./images/common/icon/telegram.png": 1576,
	"./images/common/icon/twitter-c.png": 1480,
	"./images/common/icon/twitter.png": 1572,
	"./images/common/icon/user_login.png": 1481,
	"./images/common/icon/vk-c.png": 1070,
	"./images/common/icon/vk.png": 1375,
	"./images/common/icon/wallet.png": 1482,
	"./images/common/icon/whatapp-c.png": 1483,
	"./images/common/icon/whatsapp.png": 1573,
	"./images/common/id-banner.jpeg": 1484,
	"./images/common/landscape-guide/arrow.png": 604,
	"./images/common/landscape-guide/phone1.png": 605,
	"./images/common/landscape-guide/phone2.png": 606,
	"./images/common/loading.gif": 1724,
	"./images/common/loading.png": 1485,
	"./images/common/loading.svg": 1725,
	"./images/common/logo-1.png": 1486,
	"./images/common/logo.png": 1074,
	"./images/common/mask.png": 1487,
	"./images/common/pay-result-header.png": 1488,
	"./images/common/payment-icon/03.png": 1489,
	"./images/common/payment-icon/101.png": 1490,
	"./images/common/payment-icon/103.png": 1491,
	"./images/common/payment-icon/106.png": 1492,
	"./images/common/payment-icon/107.png": 1493,
	"./images/common/payment-icon/117.png": 1494,
	"./images/common/payment-icon/118001.png": 1495,
	"./images/common/payment-icon/118002.png": 1496,
	"./images/common/payment-icon/129.png": 1497,
	"./images/common/payment-icon/A1.png": 1498,
	"./images/common/payment-icon/A11.png": 1499,
	"./images/common/payment-icon/A12.png": 1500,
	"./images/common/payment-icon/A18.png": 1501,
	"./images/common/payment-icon/A2.png": 1502,
	"./images/common/payment-icon/A35.png": 1503,
	"./images/common/payment-icon/A36.png": 1504,
	"./images/common/payment-icon/A7.png": 1505,
	"./images/common/payment-icon/AKULAKU.png": 1506,
	"./images/common/payment-icon/Boleto.png": 1507,
	"./images/common/payment-icon/CardVirtual.png": 1508,
	"./images/common/payment-icon/CreditCard.png": 1509,
	"./images/common/payment-icon/DepositExpress.png": 1510,
	"./images/common/payment-icon/Lottery.png": 1511,
	"./images/common/payment-icon/PIX.png": 1512,
	"./images/common/payment-icon/SHOPEEPAY.png": 1513,
	"./images/common/payment-icon/Wallet-Mercadopago.png": 1514,
	"./images/common/payment-icon/Wallet-PicPay.png": 1515,
	"./images/common/qrcode.png": 1516,
	"./images/common/region.png": 1517,
	"./images/common/result/insufficient-balance-new.png": 1205,
	"./images/common/result/insufficient-balance.png": 1518,
	"./images/common/result/result_error.png": 1348,
	"./images/common/result/result_success.png": 1349,
	"./images/common/ru-banner.jpeg": 1519,
	"./images/common/ru_icon.png": 1520,
	"./images/common/select_icon_blue.png": 1521,
	"./images/common/selected_icon.png": 1522,
	"./images/common/sold-out.png": 1123,
	"./images/common/tabbar/about-1.png": 618,
	"./images/common/tabbar/about.png": 615,
	"./images/common/tabbar/home-1.png": 610,
	"./images/common/tabbar/home.png": 607,
	"./images/common/tabbar/order-1.png": 614,
	"./images/common/tabbar/order.png": 611,
	"./images/common/tabbar/silvery-about.png": 616,
	"./images/common/tabbar/silvery-home.png": 608,
	"./images/common/tabbar/silvery-order.png": 612,
	"./images/common/tabbar/white-about.png": 617,
	"./images/common/tabbar/white-home.png": 609,
	"./images/common/tabbar/white-order.png": 613,
	"./images/common/tips/coupon.png": 1373,
	"./images/common/tips/message.png": 1372,
	"./images/common/tips/no-data.png": 1011,
	"./images/common/tips/no-data__for_dark_bg.png": 1002,
	"./images/common/tips/no-info.png": 1026,
	"./images/common/tips/no-network.png": 1027,
	"./images/common/toplupe-detail.png": 1523,
	"./images/common/toplupe-logo-about.png": 1410,
	"./images/common/toplupe-logo.png": 1042,
	"./images/common/toplupe-orange.png": 1524,
	"./images/common/toplupe.png": 1411,
	"./images/common/twitter.png": 1525,
	"./images/common/twitter_blackandwhite.png": 1526,
	"./images/common/whatsapp.png": 1527,
	"./images/common/whatsapp_blackandwhite.png": 1528,
	"./images/couponList/history-coupon-icon.png": 1529,
	"./images/detail/abIcon.png": 1726,
	"./images/detail/add-desktop-icon.jpg": 1727,
	"./images/detail/box-gift.png": 1589,
	"./images/detail/common/Soldout-M.png": 1728,
	"./images/detail/common/Soldout-pc.png": 1729,
	"./images/detail/common/goTop.png": 1590,
	"./images/detail/common/subscript.png": 1730,
	"./images/detail/common/success.png": 1124,
	"./images/detail/common/tips-for-dark.png": 1206,
	"./images/detail/common/tips.png": 1075,
	"./images/detail/customer-service.svg": 1731,
	"./images/detail/dark_theme/package-discount.png": 1732,
	"./images/detail/dark_theme/payment-promotion.png": 1733,
	"./images/detail/desconto-new.png": 1530,
	"./images/detail/details-tips.png": 1734,
	"./images/detail/discount-icon.png": 1412,
	"./images/detail/discount.png": 1735,
	"./images/detail/free-fire/cardActiveBgImg.png": 1736,
	"./images/detail/free-fire/desktop/cardActiveBgImg.png": 1737,
	"./images/detail/free-fire/desktop/submit-bg.png": 1738,
	"./images/detail/free-fire/desktop/uid-success-bg.png": 1739,
	"./images/detail/free-fire/icon.png": 1740,
	"./images/detail/free-fire/logo.png": 1741,
	"./images/detail/free-fire/submit-bg.png": 1742,
	"./images/detail/free-fire/success.png": 1743,
	"./images/detail/free-fire/uid-success-bg.png": 1744,
	"./images/detail/free-fire/userid-tip.png": 1745,
	"./images/detail/freefire/banner.jpg": 1746,
	"./images/detail/freefire/desktop/banner.png": 1747,
	"./images/detail/freefire/facebook-marketing.jpg": 1748,
	"./images/detail/freefire/ff-discount.png": 1749,
	"./images/detail/freefire/freefire-uid-guide.png": 1750,
	"./images/detail/freefire/icon.png": 620,
	"./images/detail/freefire/logo.png": 1751,
	"./images/detail/freefire/selected_icon.png": 1752,
	"./images/detail/freefire/uid_checked-1.png": 1753,
	"./images/detail/freefire/uid_checked.png": 1754,
	"./images/detail/gd.png": 1755,
	"./images/detail/genshin/banner.jpg": 1756,
	"./images/detail/genshin/card-background.png": 1757,
	"./images/detail/genshin/desktop/banner.png": 1758,
	"./images/detail/genshin/desktop/card-background.png": 1759,
	"./images/detail/genshin/discount-bg.png": 1760,
	"./images/detail/genshin/discount-icon.png": 1761,
	"./images/detail/genshin/discount_background.png": 1762,
	"./images/detail/genshin/icon.png": 315,
	"./images/detail/genshin/logo.png": 1763,
	"./images/detail/genshin/recharge-guide.png": 1764,
	"./images/detail/genshin/selected_icon-1.png": 1765,
	"./images/detail/genshin/selected_icon.png": 1766,
	"./images/detail/genshin/submit-bg-pre-disable.png": 1767,
	"./images/detail/genshin/submit-bg-pre.png": 1768,
	"./images/detail/genshin/submit-bg.png": 1769,
	"./images/detail/genshin/tips.png": 1770,
	"./images/detail/genshin/title_cover.png": 1771,
	"./images/detail/genshin/uid_checked.png": 1772,
	"./images/detail/genshin/uid_tip_br.png": 1773,
	"./images/detail/genshin/uid_tip_id.png": 1774,
	"./images/detail/genshin/uid_tip_ru.png": 1775,
	"./images/detail/goc-h5.png": 1207,
	"./images/detail/hot_bg.png": 1776,
	"./images/detail/infinity-kingdom/sku-guide-br.jpg": 1777,
	"./images/detail/infinity-kingdom/sku-guide-id.jpg": 1778,
	"./images/detail/infinity-kingdom/uid-guide.jpg": 1779,
	"./images/detail/infinity-kingdom/userid-tip.jpg": 1780,
	"./images/detail/lordsmobile/banner.jpg": 1781,
	"./images/detail/lordsmobile/button_background.png": 1782,
	"./images/detail/lordsmobile/button_background_disabled.png": 1783,
	"./images/detail/lordsmobile/desktop/banner.png": 1784,
	"./images/detail/lordsmobile/desktop/icon.png": 1785,
	"./images/detail/lordsmobile/discount_background.png": 1786,
	"./images/detail/lordsmobile/icon.png": 621,
	"./images/detail/lordsmobile/logo.png": 1787,
	"./images/detail/lordsmobile/selected_icon.png": 1788,
	"./images/detail/lordsmobile/sku-detail/sku-detail-bg.png": 1789,
	"./images/detail/lordsmobile/submit-bg.png": 1790,
	"./images/detail/lordsmobile/tips.png": 1791,
	"./images/detail/lordsmobile/title_cover.png": 1792,
	"./images/detail/lordsmobile/uid_background.png": 1793,
	"./images/detail/lordsmobile/uid_checked.png": 1794,
	"./images/detail/lordsmobile/userid-tip.jpg": 1795,
	"./images/detail/menu-banner.png": 1796,
	"./images/detail/mobile-legends/banner.jpg": 1797,
	"./images/detail/mobile-legends/default-uid.png": 1798,
	"./images/detail/mobile-legends/desktop/banner.png": 1799,
	"./images/detail/mobile-legends/desktop/icon.png": 1800,
	"./images/detail/mobile-legends/desktop/logo.png": 1801,
	"./images/detail/mobile-legends/desktop/new-banner.png": 1097,
	"./images/detail/mobile-legends/desktop/new-coupon-tips.png": 1802,
	"./images/detail/mobile-legends/desktop/new-hander-logo.png": 1007,
	"./images/detail/mobile-legends/desktop/new-logo.png": 1803,
	"./images/detail/mobile-legends/discount_background.png": 1804,
	"./images/detail/mobile-legends/horizontal/tip-icon1.png": 1805,
	"./images/detail/mobile-legends/horizontal/tip-icon2.png": 1806,
	"./images/detail/mobile-legends/horizontal/tip-icon3.png": 1807,
	"./images/detail/mobile-legends/horizontal/uid-banner.jpg": 1808,
	"./images/detail/mobile-legends/horizontal/uid-guide1.jpg": 1809,
	"./images/detail/mobile-legends/horizontal/uid-guide2.jpg": 1810,
	"./images/detail/mobile-legends/icon.png": 1811,
	"./images/detail/mobile-legends/id-uid.png": 1812,
	"./images/detail/mobile-legends/logo.png": 1813,
	"./images/detail/mobile-legends/my-uid.png": 1814,
	"./images/detail/mobile-legends/ru-uid.png": 1815,
	"./images/detail/mobile-legends/submit-bg-disable.png": 1816,
	"./images/detail/mobile-legends/submit-btn-bg.png": 1817,
	"./images/detail/mobile-legends/submit_border.png": 1818,
	"./images/detail/mobile-legends/title_cover.png": 1819,
	"./images/detail/promotion-image.png": 1820,
	"./images/detail/pubgm/active-package-bg.png": 1821,
	"./images/detail/pubgm/banner.jpg": 1822,
	"./images/detail/pubgm/br/step1.png": 1823,
	"./images/detail/pubgm/br/step2.png": 1824,
	"./images/detail/pubgm/br/step3.png": 1825,
	"./images/detail/pubgm/desktop/banner.png": 1826,
	"./images/detail/pubgm/desktop/icon.png": 1827,
	"./images/detail/pubgm/discount.png": 1828,
	"./images/detail/pubgm/discount_background.png": 1829,
	"./images/detail/pubgm/guide-to-share.jpg": 1830,
	"./images/detail/pubgm/icon.png": 622,
	"./images/detail/pubgm/id/step1.png": 1831,
	"./images/detail/pubgm/id/step2.png": 1832,
	"./images/detail/pubgm/id/step3.png": 1833,
	"./images/detail/pubgm/logo.png": 1591,
	"./images/detail/pubgm/package-logo.png": 1834,
	"./images/detail/pubgm/payment-promotion.png": 1835,
	"./images/detail/pubgm/pubgm-h-bg.png": 1836,
	"./images/detail/pubgm/pubgm-hs-bg.png": 1837,
	"./images/detail/pubgm/pubgm-hs-mask.jpg": 1592,
	"./images/detail/pubgm/selected_icon.png": 1838,
	"./images/detail/pubgm/sku-select-bg.jpg": 1839,
	"./images/detail/pubgm/sold-out-GT.png": 1840,
	"./images/detail/pubgm/sold-out.png": 1841,
	"./images/detail/pubgm/submit-bg.png": 1842,
	"./images/detail/pubgm/title_cover.png": 1843,
	"./images/detail/pubgm/userid-tip-order.png": 1531,
	"./images/detail/pubgm/userid-tip.jpg": 1844,
	"./images/detail/state-of-survival/banner.jpg": 1845,
	"./images/detail/state-of-survival/clock.png": 1413,
	"./images/detail/state-of-survival/desktop/banner.png": 1846,
	"./images/detail/state-of-survival/desktop/icon.png": 1847,
	"./images/detail/state-of-survival/desktop/logo.png": 1848,
	"./images/detail/state-of-survival/detail-btn-bg.png": 1849,
	"./images/detail/state-of-survival/discount.png": 1850,
	"./images/detail/state-of-survival/discount_background.png": 1851,
	"./images/detail/state-of-survival/icon.png": 1852,
	"./images/detail/state-of-survival/locked.png": 1098,
	"./images/detail/state-of-survival/logo.png": 1853,
	"./images/detail/state-of-survival/sku-detail-bg.jpg": 1854,
	"./images/detail/state-of-survival/sku-detail-bg.png": 1855,
	"./images/detail/state-of-survival/sku-detail.png": 1856,
	"./images/detail/state-of-survival/sku-placeholder.jpg": 1857,
	"./images/detail/state-of-survival/sku-popup-bg.jpg": 1858,
	"./images/detail/state-of-survival/title_cover.png": 1859,
	"./images/detail/state-of-survival/userid-tip.jpg": 1860,
	"./images/detail/subscripts/tag.png": 1861,
	"./images/detail/tips.png": 1862,
	"./images/detail/uid_error.png": 1125,
	"./images/detail/vector.png": 1863,
	"./images/emails/bg.png": 1532,
	"./images/emails/logo.png": 1864,
	"./images/feedback/QA.png": 1865,
	"./images/feedback/account.png": 1533,
	"./images/feedback/background.png": 1866,
	"./images/feedback/bad.png": 1867,
	"./images/feedback/check.png": 1868,
	"./images/feedback/game.png": 1534,
	"./images/feedback/good.png": 1869,
	"./images/feedback/history.png": 1535,
	"./images/feedback/order.png": 1536,
	"./images/feedback/pic.png": 1870,
	"./images/feedback/required.png": 1871,
	"./images/feedback/right-angle.png": 1872,
	"./images/feedback/warn.png": 1873,
	"./images/home/background.png": 1874,
	"./images/home/banner/banner2/call-me-emperor.jpg": 1875,
	"./images/home/banner/banner2/free-fire.jpg": 1876,
	"./images/home/banner/banner2/game-of-khans.jpg": 1877,
	"./images/home/banner/banner2/game-of-sultans.jpg": 1878,
	"./images/home/banner/banner2/genshin.jpg": 1879,
	"./images/home/banner/banner2/hago.jpg": 1880,
	"./images/home/banner/banner2/infinity-kingdom.jpg": 1881,
	"./images/home/banner/banner2/infinity-war.jpg": 1882,
	"./images/home/banner/banner2/lordsmobile.jpg": 1883,
	"./images/home/banner/banner2/mobile-legends.jpg": 1884,
	"./images/home/banner/banner2/off-icon.png": 1885,
	"./images/home/banner/banner2/pubgm.jpg": 1886,
	"./images/home/banner/banner2/shining-nikki.jpg": 1887,
	"./images/home/banner/banner2/state-of-survival.jpg": 1888,
	"./images/home/banner/banner3/call-me-emperor.jpg": 1889,
	"./images/home/banner/banner3/game-of-sultans.jpg": 1890,
	"./images/home/banner/banner3/genshin.jpg": 1891,
	"./images/home/banner/banner3/hago.jpg": 1892,
	"./images/home/banner/banner3/infinity-kingdom.jpg": 1893,
	"./images/home/banner/banner3/infinity-war.jpg": 1894,
	"./images/home/banner/banner3/lordsmobile.jpg": 1895,
	"./images/home/banner/banner3/mobile-legends.jpg": 1896,
	"./images/home/banner/banner3/off-icon.png": 1897,
	"./images/home/banner/banner3/pubgm.jpg": 1898,
	"./images/home/banner/banner3/shining-nikki.jpg": 1899,
	"./images/home/banner/banner3/state-of-survival.jpg": 1900,
	"./images/home/christmas/Christmas-button.png": 1901,
	"./images/home/christmas/Christmas-coupon-1.png": 1902,
	"./images/home/christmas/Christmas-coupon-2.png": 1903,
	"./images/home/christmas/Christmas-coupon-3.png": 1904,
	"./images/home/christmas/Christmas-coupon-back.png": 1905,
	"./images/home/christmas/Christmas-hand.png": 1906,
	"./images/home/christmas/close.png": 1907,
	"./images/home/crm-back.png": 1537,
	"./images/home/crm-close.png": 1538,
	"./images/home/list/crunchyroll.jpg": 1908,
	"./images/home/list/freefire.jpg": 1909,
	"./images/home/list/genshin.jpg": 1910,
	"./images/home/list/hago.jpg": 1911,
	"./images/home/list/lordsmobile.jpg": 1912,
	"./images/home/list/mobilelegends.jpg": 1913,
	"./images/home/list/pubg.jpg": 1914,
	"./images/home/list/tinder.jpg": 1915,
	"./images/home/seckill/genshin.png": 1916,
	"./images/home/seckill/mlbb.png": 1917,
	"./images/home/seckill/pubgm.png": 1918,
	"./images/home/seckill/seckill_bg.png": 1919,
	"./images/home/seckill/seckill_logo.png": 1920,
	"./images/home/swiper-bg__PC.png": 1921,
	"./images/home/title.png": 1922,
	"./images/home/title__vertical-dot.png": 1923,
	"./images/kcard/bg.jpg": 1350,
	"./images/kcard/formBg.png": 1351,
	"./images/kcard/rulesBg.png": 1539,
	"./images/member/backBanner.png": 1127,
	"./images/member/backBanner_pc.png": 1128,
	"./images/member/birthday_v1.png": 1210,
	"./images/member/birthday_v2.png": 1211,
	"./images/member/c_sv1.png": 1212,
	"./images/member/c_sv2.png": 1213,
	"./images/member/c_sv3.png": 1214,
	"./images/member/c_sv4.png": 1215,
	"./images/member/c_sv5.png": 1216,
	"./images/member/c_v1.png": 1217,
	"./images/member/c_v2.png": 1218,
	"./images/member/c_v3.png": 1219,
	"./images/member/c_v4.png": 1220,
	"./images/member/c_v5.png": 1221,
	"./images/member/c_v6.png": 1222,
	"./images/member/card1.png": 1223,
	"./images/member/cardBck.png": 1224,
	"./images/member/card_sv1.png": 1225,
	"./images/member/card_sv2.png": 1226,
	"./images/member/card_sv3.png": 1227,
	"./images/member/card_sv4.png": 1228,
	"./images/member/card_sv5.png": 1229,
	"./images/member/card_v1.png": 1230,
	"./images/member/card_v2.png": 1231,
	"./images/member/card_v3.png": 1232,
	"./images/member/card_v4.png": 1233,
	"./images/member/card_v5.png": 1234,
	"./images/member/card_v6.png": 1235,
	"./images/member/close.png": 1129,
	"./images/member/coupon-icon.png": 1116,
	"./images/member/coupons_v1.png": 1236,
	"./images/member/coupons_v2.png": 1237,
	"./images/member/d_sv1.png": 1238,
	"./images/member/d_sv2.png": 1239,
	"./images/member/d_sv3.png": 1240,
	"./images/member/d_sv4.png": 1241,
	"./images/member/d_sv5.png": 1242,
	"./images/member/d_v1.png": 1243,
	"./images/member/d_v2.png": 1244,
	"./images/member/d_v3.png": 1245,
	"./images/member/d_v4.png": 1246,
	"./images/member/d_v5.png": 1247,
	"./images/member/d_v6.png": 1248,
	"./images/member/dlock.png": 1249,
	"./images/member/exclusive_v1.png": 1250,
	"./images/member/exclusive_v2.png": 1251,
	"./images/member/fast_v1.png": 1252,
	"./images/member/fast_v2.png": 1253,
	"./images/member/game-logo.png": 1037,
	"./images/member/games/call-me-emperor.png": 1254,
	"./images/member/games/free-fire.png": 1255,
	"./images/member/games/game-of-khans.png": 1256,
	"./images/member/games/game-of-sultans.png": 1257,
	"./images/member/games/genshin.png": 1258,
	"./images/member/games/guardians-of-cloudia.png": 1259,
	"./images/member/games/hago.png": 1260,
	"./images/member/games/infinity-kingdom.png": 1261,
	"./images/member/games/infinity-war.png": 1262,
	"./images/member/games/kungfu-legend.png": 1263,
	"./images/member/games/lordsmobile.png": 1264,
	"./images/member/games/mobile-legends.png": 1265,
	"./images/member/games/pubgm.png": 1266,
	"./images/member/games/puzzles-survival.png": 1267,
	"./images/member/games/shining-nikki.png": 1268,
	"./images/member/games/soul-land3d.png": 1269,
	"./images/member/games/star-maker.png": 1270,
	"./images/member/games/state-of-survival.png": 1271,
	"./images/member/games/toplupe.png": 1272,
	"./images/member/games/turbo-vpn.png": 1273,
	"./images/member/games/vpn-proxy-master.png": 1274,
	"./images/member/kachshop.png": 1275,
	"./images/member/kb.png": 1117,
	"./images/member/kcoin-icon.png": 1118,
	"./images/member/kd_v1.png": 1276,
	"./images/member/kd_v2.png": 1277,
	"./images/member/l-0.png": 1278,
	"./images/member/l-1.png": 1279,
	"./images/member/lock.png": 1280,
	"./images/member/medal_svip1.png": 1077,
	"./images/member/medal_svip2.png": 1078,
	"./images/member/medal_svip3.png": 1079,
	"./images/member/medal_svip4.png": 1080,
	"./images/member/medal_svip5.png": 1081,
	"./images/member/medal_vip1.png": 1082,
	"./images/member/medal_vip2.png": 1083,
	"./images/member/medal_vip3.png": 1084,
	"./images/member/medal_vip4.png": 1085,
	"./images/member/medal_vip5.png": 1086,
	"./images/member/medal_vip6.png": 1087,
	"./images/member/mlbb.png": 1281,
	"./images/member/pleasantly_v1.png": 1282,
	"./images/member/pleasantly_v2.png": 1283,
	"./images/member/portrait_v1.png": 1284,
	"./images/member/portrait_v2.png": 1285,
	"./images/member/privilege.png": 1286,
	"./images/member/prop_v1.png": 1287,
	"./images/member/prop_v2.png": 1288,
	"./images/member/r-0.png": 1289,
	"./images/member/r-1.png": 1290,
	"./images/member/sv1.png": 1291,
	"./images/member/sv2.png": 1292,
	"./images/member/sv3.png": 1293,
	"./images/member/sv4.png": 1294,
	"./images/member/tcKgold.png": 1295,
	"./images/member/userinfo_bg.png": 1296,
	"./images/member/users.png": 1297,
	"./images/member/v1.png": 1298,
	"./images/member/v2.png": 1299,
	"./images/member/v3.png": 1300,
	"./images/member/v4.png": 1301,
	"./images/member/v5.png": 1302,
	"./images/member/v6.png": 1303,
	"./images/order/bg-diamond.png": 1924,
	"./images/order/coins.png": 1540,
	"./images/order/diamond.png": 1541,
	"./images/order/diamonds.png": 1925,
	"./images/order/icon-freefire.png": 1926,
	"./images/order/icon-genshin.png": 1927,
	"./images/order/icon-lordsmobile.png": 1928,
	"./images/order/icon-pay-cancel-off-v2.png": 1542,
	"./images/order/icon-pay-cancel-off-white.png": 1543,
	"./images/order/icon-pay-success-v2.png": 1544,
	"./images/order/icon-pubg.png": 1929,
	"./images/order/icon-pubgm.png": 1930,
	"./images/order/id/lordsmobile-guide.jpg": 1352,
	"./images/order/lordsmobile-guide.jpg": 1353,
	"./images/order/lordsmobile_guide_de.png": 1354,
	"./images/order/lordsmobile_guide_es.png": 1355,
	"./images/order/lordsmobile_guide_fr.png": 1356,
	"./images/order/pic-freefire.png": 439,
	"./images/order/pic-genshin.png": 624,
	"./images/order/pic-lordsmobile.png": 623,
	"./images/order/pic-pubg.png": 1931,
	"./images/order/pic-pubgm.png": 625,
	"./images/order/pubgm-code_tip1.png": 1414,
	"./images/order/pubgm-code_tip2.png": 1415,
	"./images/order/rectangle.png": 1357,
	"./images/order/ru/lordsmobile-guide.jpg": 1358,
	"./images/order/save_money.png": 1932,
	"./images/pay/banner.png": 1933,
	"./images/pay/close.png": 1593,
	"./images/pay/error.png": 1594,
	"./images/pay/header/free-fire.png": 1934,
	"./images/pay/header/genshin.png": 1935,
	"./images/pay/header/gos.png": 1936,
	"./images/pay/header/guardians-of-cloudia.png": 1937,
	"./images/pay/header/hago.png": 1938,
	"./images/pay/header/id-call-me-emperor.png": 1939,
	"./images/pay/header/id-gok.png": 1940,
	"./images/pay/header/infinity-kingdom.png": 1941,
	"./images/pay/header/infinity-war.png": 1942,
	"./images/pay/header/lordsmobile.png": 1943,
	"./images/pay/header/mobile-legends.png": 1944,
	"./images/pay/header/my-call-me-emperor.png": 1945,
	"./images/pay/header/pubgm.png": 1946,
	"./images/pay/header/ru-gok.png": 1947,
	"./images/pay/header/shining-nikki.png": 1948,
	"./images/pay/header/soul-land3d-th.png": 1949,
	"./images/pay/header/soul-land3d.png": 1950,
	"./images/pay/header/state-of-survival.png": 1951,
	"./images/pay/header/toplupe.png": 1595,
	"./images/pay/header/turbo-vpn.png": 1952,
	"./images/pay/header/vpn-proxy-master.png": 1953,
	"./images/pay/loading.png": 1596,
	"./images/pay/notice.gif": 1359,
	"./images/pay/pay-back.png": 1954,
	"./images/pay/pay-btn.png": 1955,
	"./images/pay/pay-coupon.png": 1956,
	"./images/pay/question.png": 1957,
	"./images/pay/success.png": 1597,
	"./images/wallet/K-coin-grey.png": 1307,
	"./images/wallet/K-coin.png": 987,
	"./images/wallet/bg-left-diamond-2.png": 1958,
	"./images/wallet/bg-left-diamond-grey-2.png": 1959,
	"./images/wallet/bg-left-diamond-grey.png": 1960,
	"./images/wallet/bg-left-diamond.png": 1961,
	"./images/wallet/empty-record-bg.png": 1545,
	"./images/wallet/kcardBg.png": 1962,
	"./images/wallet/popup-top-gt.png": 1963,
	"./images/wallet/popup-top.png": 1964,
	"./images/wallet/selected_icon.png": 1965,
	"./images/wallet/success-top.png": 1966,
	"./images/wallet/wallet-icon-2.png": 1308,
	"./images/wallet/wallet-icon-grey-2.png": 1309,
	"./images/wallet/wallet-icon-grey.png": 1310,
	"./images/wallet/wallet-icon.png": 1311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1340;